module.exports = "/_next/static/images/header-img-ru-52f471a42628d04b1d47cb08a45c6aad.jpg";